import { useQuery } from "@tanstack/react-query";
import { fetchData } from "../utils/api";

const useFeatureGates = (gateable_type, gateable_id = null) => {
    const { data, isPending } = useQuery({
        queryKey: ['featureGates', gateable_id],
        queryFn: async () => fetchData(`api/marketing/feature_gates?gateable_type=${gateable_type}&gateable_id=${gateable_id}`)
    });

    // featureGates is guarded on the SHAPE of `data`, never on the query's state flags. In
    // react-query v5 `isLoading` is `isPending && isFetching`, so an offline/paused fetch
    // (status 'pending', fetchStatus 'paused') reports isLoading=false, isError=false and
    // data=undefined — the old flag-based guard leaked that undefined and every consumer
    // crashed on `.includes`. Array.isArray closes that path and any other non-array response.
    // gatesLoading is ADDITIVE (H-GATE wiring, spec-H): consumers that need to distinguish
    // "gates still loading" from "gate absent" (e.g. the Agent Jobs list, which must not flash the
    // not-enabled state while the query is in flight) read it; existing consumers ignore it. It
    // tracks isPending, not isLoading, so a paused query still counts as unresolved.
    return { featureGates: Array.isArray(data) ? data : [], gatesLoading: isPending };
};

export default useFeatureGates;
